import { Language } from 'primary-schema';

export { Language };

enum Language6393 {
  Ach = 'ach',
  Aed = 'aed',
  Anu = 'anu',
  Apd = 'apd',
  Ase = 'ase',
  Bfa = 'bfa',
  Ceb = 'ceb',
  Cmn = 'cmn',
  Dak = 'dak',
  Did = 'did',
  Din = 'din',
  Dnj = 'dnj',
  Dzo = 'dzo',
  Fia = 'fia',
  Fil = 'fil',
  Hbs = 'hbs',
  Hmn = 'hmn',
  Ium = 'ium',
  Kar = 'kar',
  Knh = 'knh',
  Kuk = 'kuk',
  Kun = 'kun',
  Kyu = 'kyu',
  Lao = 'lao',
  Lir = 'lir',
  Lkt = 'lkt',
  Man = 'man',
  Mev = 'mev',
  Mhi = 'mhi',
  Nan = 'nan',
  Nus = 'nus',
  Paj = 'paj',
  Pga = 'pga',
  Prs = 'prs',
  Sgn = 'sgn',
  Yue = 'yue',
}

enum Language6395 {
  Mkh = 'mkh',
  Sio = 'sio',
}

export enum LanguageOther {
  Other = 'OTHER',
}
export const LanguageWithOther = {
  ...Language,
  ...Language6393,
  ...LanguageOther,
};
export type LanguageWithOther = Language | Language6393 | Language6395 | LanguageOther;

export const languageMap: {
  [language in Language | Language6393 | Language6395 | LanguageOther]: string;
} = {
  ase: 'American Sign Language',
  cmn: 'Mandarin',
  fil: 'Filipino',
  ium: 'Iu Mien',
  aa: 'Afar',
  ab: 'Abkhazian',
  ae: 'Avestan',
  af: 'Afrikaans',
  ak: 'Akan',
  am: 'Amharic',
  an: 'Aragonese',
  ar: 'Arabic',
  as: 'Assamese',
  av: 'Avaric',
  ay: 'Aymara',
  az: 'Azerbaijani',
  ba: 'Bashkir',
  be: 'Belarusian',
  bg: 'Bulgarian',
  bh: 'Bihari',
  bi: 'Bislama',
  bm: 'Bambara',
  bn: 'Bengali',
  bo: 'Tibetan',
  br: 'Breton',
  bs: 'Bosnian',
  ca: 'Catalan',
  ce: 'Chechen',
  ch: 'Chamorro',
  co: 'Corsican',
  cr: 'Cree',
  cs: 'Czech',
  cu: 'Old Church Slavonic',
  cv: 'Chuvash',
  cy: 'Welsh',
  da: 'Danish',
  de: 'German',
  dv: 'Divehi',
  ee: 'Ewe',
  el: 'Greek',
  en: 'English',
  eo: 'Esperanto',
  es: 'Spanish',
  et: 'Estonian',
  eu: 'Basque',
  fa: 'Persian',
  ff: 'Fulah',
  fi: 'Finnish',
  fj: 'Fijian',
  fo: 'Faroese',
  fr: 'French',
  fy: 'Western Frisian',
  ga: 'Irish',
  gd: 'Scottish Gaelic',
  gl: 'Galician',
  gn: 'Guarani',
  gu: 'Gujarati',
  gv: 'Manx',
  ha: 'Hausa',
  he: 'Hebrew',
  hi: 'Hindi',
  ho: 'Hiri Motu',
  hr: 'Croatian',
  ht: 'Haitian',
  hu: 'Hungarian',
  hy: 'Armenian',
  hz: 'Herero',
  ia: 'Interlingua',
  id: 'Indonesian',
  ie: 'Interlingue',
  ig: 'Igbo',
  ii: 'Sichuan Yi',
  ik: 'Inupiaq',
  io: 'Ido',
  is: 'Icelandic',
  it: 'Italian',
  iu: 'Inuktitut',
  ja: 'Japanese',
  jv: 'Javanese',
  ka: 'Georgian',
  kg: 'Kongo',
  ki: 'Kikuyu',
  kj: 'Kwanyama',
  kk: 'Kazakh',
  kl: 'Greenlandic',
  km: 'Khmer',
  kn: 'Kannada',
  ko: 'Korean',
  kr: 'Kanuri',
  ks: 'Kashmiri',
  ku: 'Kurdish',
  kv: 'Komi',
  kw: 'Cornish',
  ky: 'Kirghiz',
  la: 'Latin',
  lb: 'Luxembourgish',
  lg: 'Ganda',
  li: 'Limburgish',
  ln: 'Lingala',
  lo: 'Lao',
  lt: 'Lithuanian',
  lu: 'Luba',
  lv: 'Latvian',
  mg: 'Malagasy',
  mh: 'Marshallese',
  mi: 'Maori',
  mk: 'Macedonian',
  ml: 'Malayalam',
  mn: 'Mongolian',
  mr: 'Marathi',
  ms: 'Malay',
  mix: 'Mixtec',
  my: 'Burmese',
  na: 'Nauru',
  nb: 'Norwegian Bokmål',
  nd: 'North Ndebele',
  ne: 'Nepali',
  ng: 'Ndonga',
  nl: 'Dutch',
  nn: 'Norwegian Nynorsk',
  no: 'Norwegian',
  nr: 'South Ndebele',
  nv: 'Navajo',
  ny: 'Chichewa',
  oc: 'Occitan',
  oj: 'Ojibwa',
  om: 'Oromo',
  or: 'Oriya',
  os: 'Ossetian',
  pa: 'Punjabi',
  pi: 'Pali',
  pl: 'Polish',
  ps: 'Pashto',
  pt: 'Portuguese',
  'pt-BR': 'Brazilian Portuguese',
  qu: 'Quechua',
  rm: 'Romansh',
  rn: 'Kirundi',
  ro: 'Romanian',
  ru: 'Russian',
  rw: 'Kinyarwanda',
  sa: 'Sanskrit',
  sc: 'Sardinian',
  sd: 'Sindhi',
  se: 'Northern Sami',
  sg: 'Sango',
  si: 'Sinhalese',
  sk: 'Slovak',
  sl: 'Slovenian',
  sm: 'Samoan',
  sn: 'Shona',
  so: 'Somali',
  sq: 'Albanian',
  sr: 'Serbian',
  ss: 'Swati',
  st: 'Sotho',
  su: 'Sundanese',
  sv: 'Swedish',
  sw: 'Swahili',
  ta: 'Tamil',
  te: 'Telugu',
  tg: 'Tajik',
  th: 'Thai',
  ti: 'Tigrinya',
  tk: 'Turkmen',
  tl: 'Tagalog',
  tn: 'Tswana',
  to: 'Tonga',
  tr: 'Turkish',
  ts: 'Tsonga',
  tt: 'Tatar',
  tw: 'Twi',
  ty: 'Tahitian',
  ug: 'Uighur',
  uk: 'Ukrainian',
  ur: 'Urdu',
  uz: 'Uzbek',
  ve: 'Venda',
  vi: 'Vietnamese',
  vo: 'Volapuk',
  wa: 'Walloon',
  wo: 'Wolof',
  xh: 'Xhosa',
  yi: 'Yiddish',
  yo: 'Yoruba',
  za: 'Zhuang',
  zh: 'Chinese',
  OTHER: 'Other',
  [Language.Mt]: 'Maltese',
  [Language.Zu]: 'Zulu',
  [Language6393.Ach]: 'Acoli',
  [Language6393.Aed]: 'Argentina Sign Language',
  [Language6393.Anu]: 'Anuak',
  [Language6393.Apd]: 'Sudanese',
  [Language6393.Bfa]: 'Bari',
  [Language6393.Ceb]: 'Cebuano',
  [Language6393.Dak]: 'Dakota',
  [Language6393.Did]: 'Didinga',
  [Language6393.Din]: 'Dinka',
  [Language6393.Dnj]: 'Gio',
  [Language6393.Dzo]: 'Dzongkha',
  [Language6393.Fia]: 'Nobiin',
  [Language6393.Hbs]: 'Serbo-Croatian',
  [Language6393.Hmn]: 'Hmong',
  [Language6393.Kar]: 'Karen',
  [Language6393.Knh]: 'Krahn',
  [Language6393.Kuk]: 'Kuku',
  [Language6393.Kun]: 'Kunama',
  [Language6393.Kyu]: 'Kayah',
  [Language6393.Lao]: 'Lao (Laotian)',
  [Language6393.Lir]: 'Liberian',
  [Language6393.Lkt]: 'Lakota',
  [Language6393.Man]: 'Mandingo',
  [Language6393.Mev]: 'Mano',
  [Language6393.Mhi]: 'Madi',
  [Language6393.Nan]: 'Hokkien',
  [Language6393.Nus]: 'Nuer',
  [Language6393.Paj]: 'Pajulu',
  [Language6393.Pga]: 'Juba',
  [Language6393.Prs]: 'Dari',
  [Language6393.Sgn]: 'Sign Languages',
  [Language6393.Yue]: 'Chinese-Cantonese',
  [Language6395.Mkh]: 'Mon-Khmer',
  [Language6395.Sio]: 'Siouan Languages',
};

export const LANGUAGE_TO_ISO_CODE: Record<string, string> = {};
for (const [key, value] of Object.entries(languageMap)) {
  LANGUAGE_TO_ISO_CODE[value] = key;
}
